import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { clampPopoverLeft } from '../../Common/popover';

import { ReactComponent as ReceiptIcon } from '@repo/common/assets/icons/16px/icon_16px_receipt_outline.svg';
import { ReactComponent as DownloadIcon } from '@repo/common/assets/icons/16px/icon_16px_download.svg';
import { ReactComponent as PaymentExchangeIcon } from '@repo/common/assets/icons/16px/icon_16px_payment-exchange_outline.svg';

import { BaseButton } from '@repo/common';

function OptionList({
  anchorRect,
  onClose,
  status,
  originalStatus,
  // 계좌이체 결제는 PG 영수증이 없다 — false 면 "Download receipt" 를 숨긴다
  hasReceipt = true,
  onDownloadReceipt,
  onViewInvoice,
}) {
  const listRef = useRef(null);
  const [activeItem, setActiveItem] = useState(null);

  const isPending = Array.isArray(originalStatus)
    ? originalStatus.some((s) => s === 'HOLD' || s === 'OFFERED')
    : originalStatus === 'HOLD' || originalStatus === 'OFFERED';

  if (!anchorRect) return null;

  const handleItemClick = async (e, action) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveItem(action);

    if (action === 'download') {
      handleDownloadReceipt();
      return;
    }
    if (action === 'invoice') {
      handleViewInvoice();
      return;
    }
    onClose?.();
  };

  const handleDownloadReceipt = () => {
    onDownloadReceipt?.();
  };

  const handleViewInvoice = () => {
    onViewInvoice?.();
  };

  console.log(originalStatus);

  return (
    <>
      {anchorRect &&
        ReactDOM.createPortal(
          <>
            <div
              className='fixed inset-0 z-[999999] bg-transparent'
              onClick={(e) => {
                e.stopPropagation();
                onClose?.();
              }}
            />

            <div
              ref={listRef}
              onClick={(e) => e.stopPropagation()}
              style={{
                position: 'fixed',
                top: anchorRect.bottom + 6,
                left: clampPopoverLeft(anchorRect.right - 24, 182),
              }}
              className={`
                w-[182px]
                bg-grayscale-gray00 
                border border-grayscale-gray02 
                rounded-lg
                shadow-popup-04
                z-[1000000]
              `}
            >
              <div className='bg-grayscale-gray00 rounded-lg p-2'>
                <ul className='flex flex-col'>
                  <li>
                    <BaseButton
                      type='text'
                      size='m'
                      iconPosition='after'
                      icon={<ReceiptIcon />}
                      width='100%'
                      separate={true}
                      leftalign={true}
                      onClick={(e) => handleItemClick(e, 'invoice')}
                      bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 ${
                        activeItem === 'invoice'
                          ? 'bg-grayscale-gray02 text-text-primary'
                          : ''
                      }`}
                      textclass='typo-b14Strong'
                      hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                      activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                    >
                      View invoice
                    </BaseButton>
                  </li>

                  {!isPending && hasReceipt && (
                    <li>
                      <BaseButton
                        type='text'
                        size='m'
                        iconPosition='after'
                        icon={<DownloadIcon />}
                        width='100%'
                        separate={true}
                        leftalign={true}
                        onClick={(e) => handleItemClick(e, 'download')}
                        bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 ${
                          activeItem === 'download'
                            ? 'bg-grayscale-gray02 text-text-primary'
                            : ''
                        }`}
                        textclass='typo-b14Strong'
                        hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                        activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                      >
                        Download receipt
                      </BaseButton>
                    </li>
                  )}

                  {(status === 'FULLY PAID' ||
                    status === 'Confirmed' ||
                    isPending) && (
                    <li>
                      <BaseButton
                        type='text'
                        size='m'
                        iconPosition='after'
                        icon={<PaymentExchangeIcon />}
                        width='100%'
                        separate={true}
                        leftalign={true}
                        onClick={(e) => handleItemClick(e, 'extend')}
                        bgclass={`bg-grayscale-gray00 border border-grayscale-gray00 ${
                          activeItem === 'extend'
                            ? 'bg-grayscale-gray02 text-text-primary'
                            : ''
                        }`}
                        textclass='typo-b14Strong'
                        hoverclass=''
                        activeclass=''
                        isDisabled
                      >
                        Force full refund
                      </BaseButton>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </>,
          document.body,
        )}
    </>
  );
}
export default OptionList;
